var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-header"},[_c('div',{staticClass:"title"},[_c('h3',[_vm._v("UEFA Toolkit")]),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('h1',{key:_vm.title,domProps:{"textContent":_vm._s(_vm.title)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }